import { Theme } from '@mui/material';


const Chip = (theme: Theme) => {
  return {
    MuiChip: {
      variants: [
        {
          props: { color: 'default', variant: 'filled' },
          style: {
            backgroundColor: '#6b7280',
          },
        },
      ],
    },


  };
};

export default Chip;
